import { useAuth } from "core/context/auth"
import React from "react"
import { GetAlumniMentorSessions } from "domain/useCase/Admin/MentorDashboard/GetAlumniMentorSessions"
import { MentorDashboardRepositoryImpl } from "data/repository/Admin/MentorDashboardRepositoryImpl"
import { MentorDashboardAPIDataSourceImpl } from "data/API/Admin/MentorDashboardAPIDataSourceImpl"

export default function useAlumniViewModel() {
  const [loading, setLoading] = React.useState(false)
  const [alumniMentorSessions, setAlumniMentorSessions] = React.useState<any>({})
  const [inputEmails, setInputEmails] = React.useState<any>("")
  const [alumniEmails, setAlumniEmails] = React.useState<any>([])

  const { auth } = useAuth()

  const getAlumiMentorSessions = new GetAlumniMentorSessions(
    new MentorDashboardRepositoryImpl(new MentorDashboardAPIDataSourceImpl())
  )

  function handleAlumniEmailsChange(e: any) {
    setInputEmails(e.target.value)
  }

  function downloadAlumniSession(data: any) {
    const headers = ["student_email", "allotted_sessions", "completed_sessions"]

    const csvContent = [
      headers.join(","),
      ...data.map((row: any) =>
        headers
          .map((header) => {
            return row[header] !== undefined ? row[header] : ""
          })
          .join(",")
      ),
    ].join("\n")

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const link = document.createElement("a")
    const url = URL.createObjectURL(blob)
    link.setAttribute("href", url)
    link.setAttribute("download", "AlumniMentorSessions.csv")
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  async function handleAlumniMentorSessions(emails: any) {
    const processedEmails = emails.split(" ").filter((email: any) => email.trim() !== "")

    setAlumniEmails(processedEmails)
    try {
      setLoading(true)
      const response = await getAlumiMentorSessions.invoke(auth, processedEmails)

      if (response?.success && Array.isArray(response.data)) {
        downloadAlumniSession(response.data)
        setAlumniMentorSessions(response.data)
      } else {
        console.error("Unexpected response structure", response)
      }

      setAlumniMentorSessions(response.data)
      setLoading(false)
    } catch (error) {
      console.error("Error fetching alumni mentor sessions: ", error)
    }
  }

  return {
    handleAlumniMentorSessions,
    alumniEmails,
    setAlumniEmails,
    handleAlumniEmailsChange,
    inputEmails,
    setInputEmails,
    loading,
  }
}
